let ticketInfo: {
  ticket: string;
} = { ticket: '' }; // 从端bridge获取的登录信息

export const setUserInfoData = (ticketInfoData: { ticket: string }) => {
  ticketInfo = ticketInfoData;
};

export const getUserInfoData = () => {
  return ticketInfo;
};
